import { render, staticRenderFns } from "./ComplaintsPage.vue?vue&type=template&id=16b55410&scoped=true"
import script from "./ComplaintsPage.vue?vue&type=script&lang=js"
export * from "./ComplaintsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b55410",
  null
  
)

export default component.exports